/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid202,
  DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid401,
  DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid404,
  DeleteApiV1ClassroomdisciplineIdChecklistItemsItemidMutationResponse,
  DeleteApiV1ClassroomdisciplineIdChecklistItemsItemidPathParams,
} from "../../types/classPlanningCheckListController/DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid.ts";

export const deleteApiV1ClassroomdisciplineIdChecklistItemsItemidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    itemId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChecklistItemsItemidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdChecklistItemsItemid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdChecklistItemsItemid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdChecklistItemsItemid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChecklistItemsItemid404>;

export const deleteApiV1ClassroomdisciplineIdChecklistItemsItemidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdChecklistItemsItemid202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdChecklistItemsItemidMutationResponse>;
